import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import AppFooter from "./AppFooter";

function Faqs() {
  const bg = {
    background: "#eceff1",
    minHeight: "100vh",
  };
  const homePath = "/";
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Can I upload a folder of PDFs?",
      answer: "Folders currently CAN NOT be accepted, however you can upload multiple PDFs at once (On Windows, hold down the 'Shift' key and select all files you wish to convert)."
    },
    {
      question: "How long will my bank statement take to convert?",
      answer:
        "Conversion takes an average of 6 seconds per page, although some formats of statement can take shorter, or longer, depending on font, quality and layout.",
    },
    {
      question: "My bank is supported and the format is approved, but the resulting Excel file doesn't look right. What can I do?",
      answer:
        "Please contact us directly, with a brief description of the problem, and a statement sample. We'll try our best to get the issue resolved within 48 hours of your email.",
    },
    {
      question: "The converter is stuck at 0s remaining. Is something wrong?",
      answer:
        "This can be normal for a few minutes with some statements, especially those with a high number of pages. Wait a few minutes to see if the issue persists. Also check that you have uploaded an unecrypted PDF file. Other file formats are not currently supported. If the issue persists for longer than a few minutes, feel free to contact us directly.",
    },
    {
      question: "How to redact information from a sample statement? What should I redact?",
        answer: (
        <>
          We recommend using a free blurring tool, such as{" "}
          <a
            href="https://blurshot.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            blurshot.io
          </a>
          . Please redact anything personally identifiable, particularly any names,
          addresses and bank details.
        </>
      ),
    },
    {
      question: "How is my data stored?",
      answer:
        "Bank statements and generated Excel files are stored temporarily in secure cloud storage for up to 24 hours so you can download the output from your account. After that, they are automatically deleted.",
    },
  ];

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="app-container" style={bg}>
      <header className="app-header">
        <div className="header-content">
          <Link to={homePath} className="simple-brand-link">
            <span className="simple-brand-mark" aria-hidden="true">S</span>
            <span className="simple-brand-text">StatementIQ</span>
          </Link>
        </div>
      </header>

      <main className="main-content faqs-pro-page overlay">
        <section className="faqs-pro-shell">
          <div className="faqs-pro-head">
            <h1>Frequently Asked Questions</h1>
            <p>
              Quick answers about uploads, supported formats, conversion behavior,
              and troubleshooting.
            </p>
            <p>
              Need direct help? Email{" "}
              <a href="mailto:support@statementiq.co.uk">
                support@statementiq.co.uk
              </a>
              . For policy details, view our <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </div>

          <div className="faqs-pro-list">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <article key={index} className={`faqs-pro-item ${isOpen ? "is-open" : ""}`}>
                  <button
                    type="button"
                    className="faqs-pro-question"
                    onClick={() => toggleAnswer(index)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${index}`}
                  >
                    <span>{faq.question}</span>
                    <span className="faqs-pro-icon">{isOpen ? "−" : "+"}</span>
                  </button>
                  <div id={`faq-answer-${index}`} className={`faqs-pro-answer ${isOpen ? "open" : ""}`}>
                    <p>{faq.answer}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      </main>

      <AppFooter />
    </div>

  );
}

export default Faqs;
